import * as React from 'react';
import BREAK_POINTS from '../styling/media-queries';
import { div } from 'packages/smart-home-support/pages/signup-uga/components/Common';
import styled from 'styled-components';
import { BodyText } from './Typography';

const RatingContainer = styled.div`
  margin: 10px;
  display: flex;
  align-content: center;
  justify-content: center;
  background-color: #ffffff;

  width: 220px;
  height: 210px;

  @media ${BREAK_POINTS.mobileBig} {
    width: 185px;
    height: 195px;
  }

  @media ${BREAK_POINTS.tablet} {
    width: 210px;
    height: 190px;
  }

  @media ${BREAK_POINTS.desktop} {
    width: 220px;
    height: 210px;
  }
`;

const RatingContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center;
  margin: 40px 0px;
  color: #1b1b1b;
  width: 100%;

  font-weight: normal;
`;

const RatingSource = styled.div`
  font-weight: bold;
  font-size: 16px;
  margin: 0px 16px;

  @media ${BREAK_POINTS.mobile} {
    height: unset;
  }

  @media ${BREAK_POINTS.mobileBig} {
    height: 40px;
  }

  @media ${BREAK_POINTS.tablet} {
    height: unset;
  }
`;

const RatingImageBox = styled.div`
  font-size: 16px;
  height: 34px;
`;

const RatingStarsImage = styled.img``;

const RatingText = styled(BodyText)`
  color: #1b1b1b;
`;

const RatingLink = styled.a`
  color: inherit;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const formatNumReviews = (numReviews: number) => {
  return numReviews.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
};

const RatingBox: React.SFC<{
  ratingSource: string;
  starsImage: string;
  ratingText: string;
  numReviews: number;
  linkAddress?: string;
}> = (props) => {
  const reviewText = `${formatNumReviews(props.numReviews)} + REVIEWS`;
  return (
    <RatingContainer>
      <RatingContent>
        <RatingSource>{props.ratingSource}</RatingSource>
        <RatingImageBox>
          <RatingStarsImage src={props.starsImage} />
        </RatingImageBox>
        <RatingText>
          {props.ratingText}
          <br />
          {props.linkAddress ? <RatingLink href={props.linkAddress}>{reviewText}</RatingLink> : reviewText}
        </RatingText>
      </RatingContent>
    </RatingContainer>
  );
};

export default RatingBox;



// WEBPACK FOOTER //
// ./packages/smart-home-support/components/RatingBox.tsx